import { render, staticRenderFns } from "./mygroup.vue?vue&type=template&id=14e06724&scoped=true"
import script from "./mygroup.vue?vue&type=script&lang=js"
export * from "./mygroup.vue?vue&type=script&lang=js"
import style0 from "./mygroup.vue?vue&type=style&index=0&id=14e06724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e06724",
  null
  
)

export default component.exports